import { Box, Button } from "@shopify/polaris";
import React, { useEffect, useState } from "react";
import intl from "../../../../i18n/intl";
import { reqGetNewSubscribeList, reqPostNewSubscribeChange, } from "../../../../api";
import PersonalAgentModal from "../../SubscriptionPaid/components/PersonalAgentModal";
import FeedBenefitsModal from "./FeedBenefitsModal";
import ShopifyModal from "../../../../components/ShopifyModal";

const PlanNewBox = ({ open, handleOffPlanModal,toastFun }) => {
  const [planList, setPlanList] = useState([
    {
      name: "PLUS",
      dsc: "Powerful features for scaling your business",
      symbol: "$",
      id: 2,
      title_icon: "/order_fulfillment/plus_icon.png",
      popular: "Recommended",
      price: "49.9",
      oldPrice: "79",
      date: "Monthly",
      isFree: true,
      type: 1,
      button: "Start 7-day free trial",
      link: "",
      discount: 0,
      discount_time: 0,
      discount_day: 0,
      money: 49.9,
      loading: false,
      disabled: false,
      level: 2,
      limitation: {
        sourcing_num: 3,
        ali_product_num: 10,
        dsm_product_num: 10,
        temu_product_num: 10,
      },
      common: [
        "Access to Top-selling Products",
        "Vip Shipping Methods",
        "Full Order Tracking",
      ],
      dscList: [
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "799 points",
          strong: true,
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "60 expert sourcing requests per month",
          tip_p:
            "After you submit a sourcing request, our expert sourcing specialists will conduct product searches and provide quotations within 1 to 3 days.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Access to 1M+ Products",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "24/7 VIP Support",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Dedicated Manager",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "5000 AliExpress Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "5000 Temu Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "5000 DSM Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Access to Winning Products",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Bulk Product Sourcing",
          tip_p: "",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Advanced Auto Pricing",
          tip_p:
            "Supports you to initiate product sourcing for all the products in your store that are currently on sale with just one click, thereby changing the suppliers of the products to Dropshipman.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Order Auto Sourcing",
          tip_p:
            "You can set default payment methods and shipping channels, and when orders from your store are synced to Dropshipman, the payment will be automatically completed without the need for manual payment.",
          tip_icon: "/sub/sub_tip.png",
        },

        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Automated Fulfillment",
          tip_p:
            "From the moment your order is successfully placed, we create an order tracking process for you that includes order confirmation, product quality inspection, product shipment, and package transportation, allowing you to stay up-to-date with your order in real-time.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Advanced Product Quality Inspection",
          tip_p:
            "Best-selling products carefully selected and recommended by sourcing experts, helping you identify profitable opportunities.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Vip Shipping Methods",
          tip_p:
            "You can set price rules based on the price tiers of the products, and when importing products, the system will automatically set the prices of the products according to the price rules you have set.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Order Tracking",
          tip_p:
            "Once you initiate product sourcing and privatize it, the product can only be sold by you and other customers will not be able to use the product that you have privatized.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Unlimited Orders Fulfillment",
          tip_p:
            "Before shipping the products, we will remove the Chinese characters and labels on the products to provide your customers with a better experience.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Remove China Label",
          tip_p:
            "Before shipping the products, we will remove the Chinese characters and labels on the products to provide your customers with a better experience.",
          tip_icon: "/sub/sub_tip.png",
        },
      ],
    },
    {
      name: "PRO",
      dsc: "All necessary features for growing business",
      symbol: "$",
      id: 1,
      title_icon: "/order_fulfillment/pro_icon.png",
      popular: "",
      price: "29.9",
      oldPrice: "49",
      date: "Monthly",
      isFree: false,
      type: 1,
      button: "Start 7-day free trial",
      link: "",
      discount: 0,
      discount_time: 0,
      discount_day: 0,
      money: 29.9,
      loading: false,
      disabled: false,
      level: 1,
      limitation: {
        sourcing_num: 3,
        ali_product_num: 10,
        dsm_product_num: 10,
        temu_product_num: 10,
      },
      common: [
        "3000 Product Imports",
        "Automatic Product Pricing, Order Sourcing, and Order Fulfillment",
        "Dedicated Manager  Services",
      ],
      dscList: [
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "499 points",
          strong: true,
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "30 sourcing requests per month",
          tip_p:
            "After you submit a sourcing request, our expert sourcing specialists will conduct product searches and provide quotations within 1 to 3 days.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Access to 1M+ Products",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "24/7 VIP Support",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Dedicated Manager Services",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "1000 AliExpress Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "1000 Temu Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "1000 DSM Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Unlimited Orders Fulfillment",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Order Auto Sourcing",
          tip_p: "",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Bulk Product Sourcing",
          tip_p:
            "Supports you to initiate product sourcing for all the products in your store that are currently on sale with just one click, thereby changing the suppliers of the products to Dropshipman.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Automated Fulfillment",
          tip_p:
            "You can set default payment methods and shipping channels, and when orders from your store are synced to Dropshipman, the payment will be automatically completed without the need for manual payment.",
          tip_icon: "/sub/sub_tip.png",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Advanced Auto Pricing",
          tip_p: "",
          tip_icon: "/sub/sub_tip.png",
        },
      ],
    },
    {
      name: "PREMIUM",
      dsc: "All Plus features, unlimited product imports, 2990 points, and Personal Agent VIP Services",
      symbol: "$",
      id: 5,
      title_icon: "/order_fulfillment/premium_icon.png",
      popular: "",
      price: "149",
      oldPrice: "199",
      date: "Monthly",
      isFree: true,
      type: 1,
      button: "Downgrade",
      link: "",
      discount: 0,
      discount_time: 0,
      discount_day: 0,
      money: 149,
      loading: false,
      disabled: false,
      level: 0,
      limitation: {
        sourcing_num: 3,
        ali_product_num: 10,
        dsm_product_num: 10,
        temu_product_num: 10,
      },
      common: [
        "Personal Agent Services",
        "Custom Brand Packaging & Cards",
        "Custom Private Storage Solutions",
      ],
      dscList: [
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          tip_icon: "/sub/sub_tip.png",
          p: "2990 points",
          tip_p: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          tip_icon: "/sub/sub_tip.png",
          p: "300 sourcing requests per month",
          tip_p: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Access to 1M+ Products",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "24/7 VIP Support",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Unlimited AliExpress Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Unlimited Temu Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Unlimited Dropshipman Product Import per month",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Access to Winning Products",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Bulk Product Sourcing",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Advanced Auto Pricing",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Order Auto Sourcing",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Automated Fulfillment",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Advanced Product Quality Inspection",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Vip Shipping Methods",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Order Tracking",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Unlimited Orders Fulfillment",
          tip_p: "",
          tip_icon: "",
        },
        {
          icon: "/sub/ok_icon.png",
          icon_next: "/sub/ok_black_icon.png",
          p: "Remove China Label",
          tip_p: "",
          tip_icon: "",
        },
      ],
      agentService: [
        "Custom Brand Packaging & Cards",
        "Custom Private Storage Solutions",
        "Personalized Trend Product Suggestions",
        "Custom Product Photography",
        "Priority Quoting for Sourcing",
        "Rigorous Product Quality Control",
        "Full Process Order Follow-up",
        "Recommended Chinese Factories & Sources",
        "Best Logistics Route Suggestions",
      ],
      agent: [
        {
          name: "Lucy Li",
          img_url: "/dashborard_sale.jpg",
          year: 5,
          rating: 4.9,
          service_tags: ["ssaaad", "adadadllss"],
        },
        {
          name: "Lucy Li",
          img_url: "/dashborard_sale.jpg",
          year: 5,
          rating: 4.9,
          service_tags: ["ssaaad", "adadadllss"],
        },
        {
          name: "Lucy Li",
          img_url: "/dashborard_sale.jpg",
          year: 5,
          rating: 4.9,
          service_tags: ["ssaaad", "adadadllss"],
        },
        {
          name: "Lucy Li",
          img_url: "/dashborard_sale.jpg",
          year: 5,
          rating: 4.9,
          service_tags: ["ssaaad", "adadadllss"],
        },
      ],
    },
  ]);
  //  挽留套餐
  const [feedModal,setFeedModal] = useState(false);
   const enhancePackageList = (
      list,
      currentPlanId,
      pricingData,
      trialDays,
      agentList,
      firstPurchase,
      isZt,
      bill_glasses_level
    ) => list.map(item => {
      const priceInfo = pricingData.find(p => p.key === item.id) || {};
      const isCurrentPlan = item.id === currentPlanId;
      const isAnnualPlan = priceInfo?.is_yearly === 1;
      let button = "";
      let disabled = false;
      if (bill_glasses_level === 1) {// 当前为年套餐页
        if (isAnnualPlan) {
          if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button =  `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            }else if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            }else {
              button = "Downgrade";
            }
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            }else {
              button = "Downgrade";
            }
          }
          
        }
      }else {
        if (isAnnualPlan) {
          if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            }else if (trialDays !== 0  && item.id !== 4) {
              button =  `Start ${trialDays}-day free trial`;
            } else {
              button = "Select Plan";
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId)
          ) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button =  `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0  && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
          
        }
        
      }
    
      return {
        ...item,
        ...priceInfo,
        first_purchase: firstPurchase,
        is_zt: isZt,
        bill_level: currentPlanId,
        agent: item.id === 5 ? agentList : [],
        button,
        disabled,
        loading:false
      };
    });
  // 获取套餐数据
    const getSubscribeList = async () => {
      try {
        let res = await reqGetNewSubscribeList();
        if (res.code === "200") {
          const {
            bill_level,
            trial_days,
            agent_list,
            first_purchase,
            is_zt,
            bill_glasses_level,
          } = res.data;
          setPremiumData((prevValue) => ({
            ...prevValue,
            agent_list: res.data.agent_list,
          }));
    
          // 处理月套餐
          const enhancedMonth = enhancePackageList(
            planList,
            bill_level,
            res.data.package.month,
            trial_days,
            agent_list,
            first_purchase,
            is_zt,
            bill_glasses_level
          );
          
  
          setPlanList(enhancedMonth)
          
        }
      } catch (error) {}
    };
  useEffect(() => {
    let isMount = false;
    if (!isMount && open) {
      getSubscribeList();
    }
    return () => {
      isMount = true;
    };
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // 升级套餐
  const handleMageUpgrade = async (
    id,
    val,
    email = "",
    social = "",
    am_id = ""
  ) => {
    let list = planList.map((item, ind) => {
      if (item.id === id) {
        return { ...item, loading: true };
      } else {
        return { ...item, disabled: true };
      }
    });
    setPlanList(list);
    try {
      let param = {
        package_id: id,
        email: email,
        social: social,
        am_id: am_id,
        is_yearly:0
      };
      if (val && val !== "") {
        param.remark = val;
      }
      let res = await reqPostNewSubscribeChange(param);
      if (res.code === "200") {
        if (res?.data?.id !== "") {
          
          if (id !== 0) {
           
            let list1 = planList.map((item, ind) => {
              if (item.id === id || id === 4 || id === 5) {
                return { ...item, loading: false };
              } else {
                return item;
              }
            });
            setPlanList(list1);
            window.top.location.href = res.data.url;
            toastFun(res.msg);
          } 
        }
      } else {
        getSubscribeList();
        toastFun(intl.get("Something wrong"));
      }
    } catch (error) {}
  };
  // 高级套餐
  const [premiumData, setPremiumData] = useState({
    open: false,
    agent_list: [],
  });
  const handlePremiumOff = () => {
    setPremiumData((prevValue) => ({
      ...prevValue,
      open: false,
    }));
  };
  return (
    <div>
      <ShopifyModal
        id="plan-new-modal"
        open={open}
        heading="Choose a plan to get started"
        size="large"
        onClose={() => {
          setFeedModal(true);
          handleOffPlanModal();
        }}
      >
        <Box className="new_plan_modal">
          <Box className="new_plan_content">
            <Box className="new_plan_content_top">
              <Box className="new_plan_content_list">
                {planList.map((item,ind)=> <Box key={ind} className="new_plan_content_list_item">
                    {item.id === 2 && (
                      <Box className="new_plan_content_list_item_reecomend">
                        Highly Recommended
                      </Box>
                    )}
                    <Box className="new_plan_content_list_item_day">
                      7 DAY FREE TRIAL
                    </Box>
                    <Box className="new_plan_content_list_item_price">
                      <strong>$0</strong>
                      <p>
                        <span>{item.name}</span>
                        <img style={{ verticalAlign: "bottom",fontSize:"20px" }} src={item.title_icon} alt='logo'/>
                      </p>
                    </Box>
                    <Box className="new_plan_content_list_item_dsc">
                      <p>
                        <strong>
                          7 Day Free Trial - No Contracts, Cancel Anytime.{" "}
                        </strong>
                        <span style={{color:'rgba(118, 118, 118, 1)'}}> Get Access To All Features! Then just</span>

                          <strong style={{ margin: "0 5px" }}>
                            $
                            {parseFloat(
                              item.money *
                                (item.discount) *
                                100
                            ).toFixed(0) / 100}
                            /mo.
                          </strong>
                          {item.discount !== 1 ? <span style={{textDecoration:'line-through',color:'rgba(118, 118, 118, 1)'}}>${item.money}</span>:''}
                      </p>
                    </Box>
                    <Box className="new_plan_content_list_item_button">
                      <Button
                        variant={item.id === 2 ? "primary" : "secondary"}
                        disabled={item.disabled}
                        loading={item.loading}
                        onClick={()=>{
                          if (item.id === 5) {
                            setPremiumData((prevValue) => ({
                              ...prevValue,
                              open: true,
                            }));
                            handleOffPlanModal()
                          }else {
                            handleMageUpgrade(item.id)
                          }
                         
                        }}
                      >
                       Select Plan
                      </Button>
                    </Box>
                    <Box className="new_plan_content_list_item_tip">
                      {item.dsc}
                    </Box>
                    <Box className="new_plan_content_list_item_feature">
                    {item.id === 5 ? "Personal agent services" : "Features"}
                    </Box>
                    <Box className="new_plan_content_list_item_ul">
                      <ul>
                        {item.dscList.map((it, j) => (
                          <li key={j}>{it.p}</li>
                        ))}
                      </ul>
                    </Box>
                  </Box>)}
                
              </Box>
            </Box>
            <Box className="new_plan_content_bottom">
              <p>
                Cancel at any time｜Trusted by top brands running on Shopify &
                Shopify Plus｜24*7 Live customer support
              </p>
            </Box>
          </Box>
        </Box>
      </ShopifyModal>

      <PersonalAgentModal
        premiumData={premiumData}
        handlePremiumOff={handlePremiumOff}
        handleMageUpgrade={handleMageUpgrade}
      />
      <FeedBenefitsModal open={feedModal}  setFeedModal={setFeedModal}/>
    </div>
  );
};

export default PlanNewBox;
